import { ExportDto, exportFile, RequestCompression } from '@ecosystem/export-api';
import { useAuthentication } from '@ecosystem/newron-client-lib';
import { useCallback } from 'react';
import { ExportFunction } from './Model';

export const useExportApi = (): { exportFile: ExportFunction } => {
  const auth = useAuthentication();

  const exportFileFn = useCallback<ExportFunction>(
    async (data: ExportDto) => {
      const token = await auth.getAccessToken();
      const file = await exportFile(data, {
        baseUrl: '/export',
        bearerToken: token ?? '',
        requestCompression: RequestCompression.GZip,
      });
      return {
        filename: file.filename,
        content: new Blob([file.content]),
      };
    },
    [auth],
  );

  return {
    exportFile: exportFileFn,
  };
};
